import apiClient from './apiClient';

export const transitService = {
  // Paginated in-transit packages with their current vehicle
  getPackages: async (params = {}) => {
    try {
      const response = await apiClient.get('/transit/packages', { params });
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Aggregate summary (totals, by vehicle, by destination) over the same filters
  getSummary: async (params = {}) => {
    try {
      const response = await apiClient.get('/transit/summary', { params });
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },
};
